import { render } from "./DoctorSelect.vue?vue&type=template&id=6a5ea3fa&scoped=true"
import script from "./DoctorSelect.vue?vue&type=script&lang=js"
export * from "./DoctorSelect.vue?vue&type=script&lang=js"

import "./DoctorSelect.vue?vue&type=style&index=0&id=6a5ea3fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5ea3fa"]])

export default __exports__